module.exports = __webpack_public_path__ + "static/img/Frame 1861.74b83e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1861.png
// module id = L3Vm
// module chunks = 12